// import qs from 'qs'
// const qsBrowserSetting = qs.parse(location.search, { ignoreQueryPrefix: true })
// const qsForceWeb = qsBrowserSetting.browser === 'web'
// // const qsForceVKHybrid = qsBrowserSetting.browser === 'vkhybrid'
// import Cookie from 'js-cookie'

const userAgent = navigator.userAgent.toLowerCase()
const iphone = /iphone/i.test(userAgent)
const ipad = /ipad/i.test(userAgent)
const ios = /ios/i.test(userAgent)
const android = /android/i.test(userAgent)
const cnQimengApp = /VIPKID启蒙/i.test(userAgent)
const qimengApp = /qimeng/i.test(userAgent)
const vkhybrid = /vkhybrid/i.test(userAgent) && (qimengApp || cnQimengApp)
const isVkhybrid = () => {
  return /vkhybrid/i.test(navigator.userAgent) && (qimengApp || cnQimengApp)
}

const isParent = () => {
  return /vkhybrid/.test(navigator.userAgent) && /parent/i.test(navigator.userAgent)
}

const wechatBrowser = /micromessenger/i.test(userAgent)

const getAppVersion = () => {
  const reg = /(qimeng|vipkid[^\/].)\/([\d\.]+)/i
  if (reg.test(userAgent)) {
    return userAgent.match(reg)[2]
  }
  return '0.0.1'
}

const compareVersion = (a, b) => {
  let result = 'equal'
  const aArray = a.split('.')
  const bArray = b.split('.')

  while (aArray.length && bArray.length && result === 'equal') {
    const aVal = Number(aArray.shift())
    const bVal = Number(bArray.shift())
    if (aVal > bVal) {
      result = 'gt'
    } else if (aVal < bVal) {
      result = 'lt'
    }
  }
  return result
}

// 兼容ios12版本 提供一个可兼容的版本
const isFromApp = () => {
  return new Promise((resolve, reject) => {
    // 如果UA检测成功直接返回
    if (isVkhybrid()) {
      return resolve(true)
    }

    // 如果Cookie检测成功直接返回
    // if (Cookie.get('isFromApp') === '1') {
    //   return resolve(true)
    // }
    return resolve(false)
    // 通过JSBridge询问服务端
    // 延时200ms 如果检测不到就认为是浏览器
    // setTimeout(() => {
    //   return resolve(false)
    // }, 200)
  })
}

const Browser = {
  qimengApp,
  ios,
  iphone,
  ipad,
  android,
  mobile: iphone || android,
  vkhybrid,
  isVkhybrid,
  isParent,
  wechatBrowser,
  isFromApp,
  getAppVersion,
  compareVersion
}

export default Browser
